import React from 'react';
import { Auth } from 'aws-amplify';
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom';
import routerPathEnum from './enums/routerPathEnum';
import signInEnum from './enums/signInEnum';
import Logout from './screens/AuthScreens/Logout';
import Loading from './screens/AuthScreens/Loading';
import ImageManagement from './screens/ImageManagement/index';
import Reports from './screens/Reports';
import ReportView from './screens/ReportView';
import WorkItemComponent from './screens/WorkItemComponent/WorkItemComponent';
import Error from './screens/Error';
import ErrorBoundary from './screens/Error/ErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';
import DarkTheme from './styles/DarkTheme';
import {
  ThemeProvider,
  lightTheme,
  CreateAccount,
  Verification,
  ForgotPassword,
  SignIn,
} from '@common-ui/ui';
import ImageEditorBatch from './screens/ImageEditorBatch';
import { ModalProvider } from './components/modals/Report';
import TIComponentTheme from './styles/TIComponentTheme';
import { SessionProvider, UserProvider } from './context';

export default function App() {
  return (
    <Router>
      <UserProvider>
        <SessionProvider>
          <ModalProvider>
            <ThemeProvider theme={DarkTheme}>
              <Switch>
                <Route exact path="/">
                  <Redirect to={routerPathEnum.LOGIN} />
                </Route>
                <Route
                  exact
                  path={routerPathEnum.IMAGES}
                  render={(values) => (
                    <ErrorBoundary>
                      <ImageManagement props={{ ...values }} />
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.REPORTS}
                  render={(values) => (
                    <ErrorBoundary>
                      <Reports props={{ ...values }} />
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={`${routerPathEnum.REPORT}/:id`}
                  render={(values) => (
                    <ErrorBoundary>
                      <ThemeProvider theme={TIComponentTheme}>
                        <ReportView props={{ ...values }} />
                      </ThemeProvider>
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.LOADING}
                  render={(values) => (
                    <ErrorBoundary>
                      <Loading props={{ ...values }} />
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.LOGOUT}
                  render={(values) => (
                    <ErrorBoundary>
                      <Logout props={{ ...values }} />
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.REGISTER}
                  render={() => (
                    <ErrorBoundary>
                      <ThemeProvider theme={lightTheme}>
                        <CreateAccount
                          product={signInEnum.BASELINE}
                          Auth={Auth}
                          onSignInRedirect={routerPathEnum.IMAGES}
                          signInPath={routerPathEnum.REGISTER}
                        />
                      </ThemeProvider>
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.VERIFY_EMAIL}
                  render={() => (
                    <ErrorBoundary>
                      <ThemeProvider theme={lightTheme}>
                        <Verification product={signInEnum.BASELINE} Auth={Auth} />
                      </ThemeProvider>
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.FORGOT_PASSWORD}
                  render={() => (
                    <ErrorBoundary>
                      <ThemeProvider theme={lightTheme}>
                        <ForgotPassword Auth={Auth} signInPath={routerPathEnum.LOGIN} />
                      </ThemeProvider>
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.WORK_ITEM}
                  render={(props) => (
                    <ErrorBoundary>
                      <WorkItemComponent {...props} />
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.LOGIN}
                  render={() => (
                    <ErrorBoundary>
                      <ThemeProvider theme={lightTheme}>
                        <SignIn
                          product={signInEnum.BASELINE}
                          description={signInEnum.APPLICATION_INFO}
                          createAccountPath={routerPathEnum.REGISTER}
                          forgotPasswordPath={routerPathEnum.FORGOT_PASSWORD}
                          onSignInRedirect={routerPathEnum.LOADING}
                          Auth={Auth}
                        />
                      </ThemeProvider>
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={`${routerPathEnum.IMAGE_EDITOR}`}
                  render={(values) => (
                    <ErrorBoundary>
                      <ImageEditorBatch props={{ ...values }} />
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.FOUR_OH_FOUR}
                  render={() => (
                    <ErrorBoundary>
                      <ThemeProvider theme={lightTheme}>
                        <Error />
                      </ThemeProvider>
                    </ErrorBoundary>
                  )}
                />
                <Route
                  exact
                  path={routerPathEnum.FIVE_OH_FIVE}
                  render={(props) => (
                    <ThemeProvider theme={lightTheme}>
                      <Error {...props} error={props.location.state?.error} />
                    </ThemeProvider>
                  )}
                />
                <Redirect to={routerPathEnum.FOUR_OH_FOUR} />
              </Switch>
            </ThemeProvider>
          </ModalProvider>
        </SessionProvider>
      </UserProvider>
    </Router>
  );
}
